import React, { useState } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";

function ProductListingAttributes(props) {

  const [attributes, setAttributes] = useState({
    itemName: "",
    brand: "",
    color: "",
    size: "",
    material: "",
    bullet1: "",
    bullet2: "",
    description: ""
  });

  const COLOR_OPTIONS = [
    "Black", "White", "Silver", "Grey", "Red", "Blue", "Navy", 
    "Green", "Yellow", "Pink", "Purple", "Orange", "Brown", "Gold", "Beige"
  ];

  const ALL_SIZES = [
    "4 × 6 in", "5 × 7 in", "6 × 8 in", "8 × 10 in", "10 × 12 in", 
    "12 × 16 in", "16 × 20 in", "18 × 24 in", "12 × 18 in", "16 × 24 in", 
    "20 × 30 in", "24 × 36 in", "32 in", "40 in", "43 in", "50 in", 
    "55 in", "65 in", "75 in", "8 × 8 in", "10 × 10 in", "12 × 12 in", 
    "16 × 16 in", "20 × 20 in", "12 × 10 × 4 in", "20 × 15 × 8 in"
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
  console.log(attributes)
  console.log(setAttributes)
    setAttributes({
      ...attributes,
      [name]: value
    });
  };

  return (

    <Container>

      <Row>

        {/* Page Title */}
        <Col md={12} className="mt-2 mb-2">
          <h4>Step 4 : Product Attributes</h4>
        </Col>


        {/* Attributes Form */}
        <Col md={12} className="ml-1 mr-4">

          <Card className="p-4">

            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">Item Name : </Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="itemName"
                  // value={attributes.itemName}
                  value="Rolling Sands 22 oz Color Changing Plastic Cups with Lids, 10 Pack, USA Made Reusable Tumblers; Includes 10 Reusable Straws; Dishwasher Safe, Frost to Green"
                  onChange={handleChange}
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">Brand : </Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="brand"
                  // value={attributes.brand}
                  value="Rolling Sands"
                  onChange={handleChange}
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">Color : </Col>
              <Col md={8}>
                {/* <Input type="select" name="color" value={attributes.color} onChange={handleChange}>
                  <option value="">-- Select Color --</option>
                  {COLOR_OPTIONS.map(color => (
                    <option key={color} value={color}>{color}</option>
                  ))}
                </Input> */}
                 <Input
                  type="text"
                  name="brand"
                  // value={attributes.brand}
                  value="Color Changing Frost to Green"
                  onChange={handleChange}
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">Size : </Col>
              <Col md={8}>
              <Input 
                type="text" 
                name="size" 
                value={"5 3/4\" H x 3 5/8\" D x 2 3/4\" B"}
                // onChange={handleChange}
              />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">Material : </Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="material"
                  // value={attributes.material}
                  value="Plastic"
                  // onChange={handleChange}
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4}><b>Bullet Point 1</b></Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="bullet1"
                  // value={attributes.bullet1}
                  value="MAGICALLY CHANGES COLOR: Fill the cups with a cold drink (below 50 degrees) or ice and watch them change to a new vibrant color. Set includes 10 reusable 22oz plastic drink cups with clear snap-on lids; 10 reusable plastic straws"
                  // onChange={handleChange}
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4}><b>Bullet Point 2</b></Col>
              <Col md={8}>
                <Input
                  type="text"
                  name="bullet2"
                  // value={attributes.bullet2}
                  // onChange={handleChange}
                  value="EASY TO CLEAN: Top shelf dishwasher safe, break-resistant, stackable cold color changing stadium cups"
                />
              </Col>
            </Row>


            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">Description : </Col>
              <Col md={8}>
                <Input
                  type="textarea"
                  rows="4"
                  name="description"
                  // value={attributes.description}
                  // onChange={handleChange}
                  value="Our BPA-Free cold color changing reusable drinking cups, lids and straws are an economical alternative to throw-away stadium party cups. The cups, lids and straws are all top shelf dishwasher safe and easy to clean by hand. If cleaning is inconvenient for your special event and you'd prefer to use them as disposable cups, they are recyclable. The clear lids snap on for a tight seal. The straw hole is located in the center of the lid. Our rigid clear reusable straws will never fall out of your tumbler cup since we have a raised ridge going around the straw near the bottom to prevent the straw form falling out unintentionally.
Our 22 ounce blank tumblers are stackable which saves space on your shelf or in storage. Since they stack, it also makes them easy for large parties and events."
                />
              </Col>
            </Row>

          </Card>

        </Col>


        {/* Navigation Buttons */}

        <Col md={12} className="mt-3 d-flex justify-content-between">

          <button
            className="btn btn-light"
            onClick={props.prevStep}
          >
            ← Back
          </button>

          <button
            className="btn btn-primary"
            onClick={props.nextStep}
          >
            Next →
          </button>

        </Col>

      </Row>

    </Container>

  );
}

export default ProductListingAttributes;